import { render, staticRenderFns } from "./StandardShareMessage.vue?vue&type=template&id=fbb6d528&"
import script from "./StandardShareMessage.vue?vue&type=script&lang=js&"
export * from "./StandardShareMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports